module.exports = __webpack_public_path__ + "img/teams.4dd58cb9.png";